import { fetchLatestYouTubeVideos } from '@core/services/youtube/youtube-service'
import { CoreError, CoreErrorCause } from '@domain/models/core-error'
import {
  MICHEL_HACKS,
  YOUTUBE_CHANNEL_URL,
  YouTubeContent,
} from '@domain/features/youtube/youtube-content'
import type { YouTubeVideo } from '@domain/models/youtube'

export class YouTubeFeature {
  public static readonly MICHEL_HACKS = YouTubeContent.MICHEL_HACKS
  public static readonly YOUTUBE_CHANNEL_URL = YouTubeContent.YOUTUBE_CHANNEL_URL

  public static async getLatestYouTubeVideos(
    count = 4,
  ): Promise<YouTubeVideo[]> {
    try {
      return await fetchLatestYouTubeVideos(count)
    } catch {
      // The webinars feature layer falls back to Firestore when YouTube is unavailable.
      return []
    }
  }
}

export async function getLatestYouTubeVideos(
  count = 4,
): Promise<YouTubeVideo[]> {
  try {
    return await YouTubeFeature.getLatestYouTubeVideos(count)
  } catch (error) {
    throw new CoreError({
      cause: CoreErrorCause.Unknown,
      context: 'Failed to fetch latest YouTube videos.',
      underlyingException: error,
    })
  }
}

export { MICHEL_HACKS, YOUTUBE_CHANNEL_URL }
